import NestableClickable from 'components/Common/NestableClickable'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import React, { PropsWithChildren, ReactNode } from 'react'
import styled from 'styled-components'
import CartReviewTileOverlay from './_CartReviewTileOverlay'
import { tileDesktopLayout } from './constants'

const LayoutWrapper = styled.div`
  border-radius: ${props => props.theme.borderRadius.S};
  background-color: ${props => props.theme.palette.neutral.default.eight};
  container-type: inline-size;

  ${mediaQueryUp.tablet} {
    border: 1px solid ${props => props.theme.palette.neutral.default.five};
  }
`

const Layout = styled.div` 
  position: relative;
  display: grid;
  gap: ${rem(8)} ${rem(16)};
  padding: ${rem(16)};
  min-height: ${rem(120)};

  ${tileDesktopLayout} {
    padding: 0;
  }

  &.with-image {
    grid-template:
      "primary-content image" auto
      "secondary-content secondary-content" auto / minmax(0, 1fr) ${rem(64)};

    ${tileDesktopLayout} {
      grid-template: "image primary-content secondary-content" auto / ${rem(190)} minmax(0, 1fr) auto;
    }
  }

  &.without-image {
    grid-template:
      "primary-content" auto
      "secondary-content" auto / minmax(0, 1fr);

    ${tileDesktopLayout} {
      grid-template: "primary-content secondary-content" auto / minmax(0, 1fr) auto;
      padding-inline-start: ${rem(16)};
    }
  }
`

const ContentWrapper = styled(NestableClickable)`
  position: relative;
`

export interface Props extends PropsWithChildren, Utils.PropsWithDataAttributes {
  banner: ReactNode
  extension?: ReactNode
  to?: string
  layout: 'with-image' | 'without-image'
  showOverlay?: boolean
  className?: string
  hideAvailabilityDetails?: boolean
}

function CartReviewTileBase({
  banner,
  extension,
  children,
  to,
  layout,
  showOverlay,
  className,
  hideAvailabilityDetails = false,
}: Props) {
  return (
    <LayoutWrapper data-testid="cart-review-tile" className={className}>
      {!hideAvailabilityDetails && banner}
      <ContentWrapper to={to} target="_blank">
        <Layout className={layout}>
          {children}
        </Layout>
        {extension}
        {showOverlay && <CartReviewTileOverlay />}
      </ContentWrapper>
    </LayoutWrapper>
  )
}

export default React.memo(CartReviewTileBase)
